export default "__VITE_ASSET__8c21c0da__"